import { ConfigProvider } from './ConfigProvider';

const getCurrentLocale = (): string => {
  const userLang = navigator.language;
  return userLang;
};

export const translate = (
  key: string,
  locale: string = getCurrentLocale().split('-')[0]
): string => {
  let keyPath = `strings/${locale}/${key}`;
  let defaultKeyPath = `strings/default/${key}`;
  if (ConfigProvider.hasConfig(keyPath)) {
    return ConfigProvider.getConfig(keyPath).toString();
  } else if (ConfigProvider.hasConfig(defaultKeyPath)) {
    return ConfigProvider.getConfig(defaultKeyPath).toString();
  }
  return `$${key}`;
};



// WEBPACK FOOTER //
// ./src/utils/Intl.ts